/**
 * Where the game server lives.
 *
 * On the web the client is served by the same Worker that runs the rooms, so
 * the current origin is right. Inside the iOS/Android shells the page is served
 * from `capacitor://localhost`, so those builds must be given a real origin at
 * build time:
 *
 *     VITE_SERVER_ORIGIN=https://playpal.example.workers.dev pnpm build
 */
const configured = (import.meta.env.VITE_SERVER_ORIGIN ?? "").trim().replace(/\/+$/, "");

const currentOrigin = typeof window === "undefined" ? "" : window.location.origin;

/** True when the page is running inside a native shell rather than a browser. */
export const isNativeShell = /^(capacitor|ionic|file):/.test(currentOrigin);

export const SERVER_ORIGIN = configured || currentOrigin;

export function apiUrl(path: string): string {
	return `${SERVER_ORIGIN}${path}`;
}

export function socketUrl(path: string): string {
	return `${SERVER_ORIGIN.replace(/^http/, "ws")}${path}`;
}

/** A native build with no server baked in can only fail confusingly — say so. */
export function configurationProblem(): string | null {
	if (isNativeShell && !configured) {
		return "This app was built without a server address. Rebuild it with VITE_SERVER_ORIGIN set.";
	}
	return null;
}
